import MyUHLStatisticsContainer from "../containers/MyUHLStatisticsContainer";

const MyUHLStatisticsPage = () => {
    return <MyUHLStatisticsContainer />;
};

export default MyUHLStatisticsPage;
